module.exports = __webpack_public_path__ + "static/media/calendar-grey.78f8b615.svg";